import {
  GreenSystemIcon,
  OrangeSystemIcon,
  RedSystemIcon,
} from "App/global-style";
import {
  CoverageAccordionHeader,
  CoverageCaption,
  CoverageExplanation,
  CoverageExplanationBulletPoint,
  CoverageIcon,
  StyledAccordion,
  StyledAccordionRow,
} from "./coverages.styles";

import { CoverageTexts } from "Store/interfaces/products/coverage";
import { TextLanguage } from "Store/texts/interfaces";
import React from "react";
import ReactMarkdown from "react-markdown";
import { needsBulletPointStyling } from "./coverages.helpers";

interface Props {
  cardId: string;
  coverages: CoverageTexts[];
  cardIsSelected?: boolean;
  includedCoverages?: boolean;
  lang: TextLanguage;
}

export const CoverageCardAccordion = ({
  cardId,
  coverages,
  cardIsSelected,
  includedCoverages,
  lang,
}: Props): React.ReactElement => {
  const renderList = (): JSX.Element[] => {
    return coverages.map((coverageText) => {
      const icons = includedCoverages ? (
        <GreenSystemIcon name="check" />
      ) : (
        <RedSystemIcon name="close" />
      );
      return (
        <StyledAccordionRow
          id={`${cardId}-${coverageText.caption[lang]}-coverage-card-accordion-row`}
          key={coverageText.caption[lang]}
          headerProps={{
            type: "button",
          }}
          header={
            <CoverageAccordionHeader selected={cardIsSelected}>
              <CoverageIcon>
                {coverageText.optional ? (
                  <OrangeSystemIcon name="add" />
                ) : (
                  icons
                )}
              </CoverageIcon>
              <CoverageCaption>{coverageText.caption[lang]}</CoverageCaption>
            </CoverageAccordionHeader>
          }
          content={coverageText.explanation[lang].map((explanation: string) => {
            if (needsBulletPointStyling(explanation)) {
              return (
                <CoverageExplanationBulletPoint
                  key={explanation}
                  selected={cardIsSelected}
                >
                  {explanation}
                </CoverageExplanationBulletPoint>
              );
            }
            return (
              <CoverageExplanation key={explanation} selected={cardIsSelected}>
                <ReactMarkdown linkTarget="_blank">{explanation}</ReactMarkdown>
              </CoverageExplanation>
            );
          })}
          isSelected={cardIsSelected}
        />
      );
    });
  };

  return <StyledAccordion>{renderList()}</StyledAccordion>;
};
